/**
 * Application Configuration - Global Constants
 *
 * Centralized configuration for the entire application.
 * These values are determined at startup and never change during the session.
 */

/**
 * Service Worker Availability
 *
 * Controls whether Service Worker is enabled for caching and offline support.
 * - true: Enable Service Worker (enables caching, offline mode, PWA features)
 * - false: Disable Service Worker (for development without caching)
 *
 * Change this line to toggle Service Worker behavior:
 * export const isSWAvailable = !!navigator.serviceWorker;  // Enable SW
 * export const isSWAvailable = false;                       // Disable SW
 */
export const isSWAvailable = !!navigator.serviceWorker; // Enable SW
//export const isSWAvailable = false;

/**
 * Production Environment Detection
 * Loaded from /settings.js served by backend at app startup
 */
export const isProduction = typeof window !== 'undefined'
  ? window.__APP_CONFIG__?.isProduction ?? true
  : true;

/**
 * Application Insights Connection String
 * Loaded from /settings.js served by backend at app startup
 */
export const appInsightsConnectionString = typeof window !== 'undefined'
  ? window.__APP_CONFIG__?.appInsights?.connectionString
  : undefined;

/**
 * Logger Level
 *
 * Controls logging output:
 * - DEBUG (0): All logs including verbose initialization info
 * - INFO (1): Important events only (recommended for production)
 * - WARN (2): Warnings and errors only
 * - ERROR (3): Errors only
 *
 * Change this line to adjust logging verbosity:
 * export const loggerLevel = 0;  // DEBUG - Enable all logs
 * export const loggerLevel = 1;  // INFO - Production (default)
 * export const loggerLevel = 2;  // WARN - Warnings only
 */
export const loggerLevel = isProduction ? 1 : 0; // INFO in prod, DEBUG in dev

// Startup logging moved to useAppInitialization.tsx to avoid circular dependency with Logger
